<template>
  <div :style="cssVars">
    <a-modal v-model="changePWModal" width="480px" :footer="null" title="" :maskClosable="false" :closable="true" :keyboard="false">
      <div class="modelHeader">密码不安全，请先修改密码</div>
      <div class="send-prompt" v-if="sendStatus.length > 0">{{sendStatus}}</div>
      <div class="formLogin">
        <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
          <div class="captcha">
            <a-form-model-item prop="verifyCode">
              <a-input size="large" v-model="ruleForm.verifyCode"  allowClear autocomplete="new-password"
                       oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 6)value = value.slice(0, 6)"
                       placeholder="请输入验证码">
                <a-button slot="addonAfter" class="captchaButton" :disabled="captchaButtonDisabled" @click="getCaptcha">
                  {{ captchaBtnContent }} </a-button>
              </a-input>
              <!--            <a-input-password v-model="ruleForm.pwd" type="password" allowClear placeholder="当前密码" />-->
            </a-form-model-item>
          </div>
          <a-form-model-item prop="newPwd">
            <a-input-password v-model="ruleForm.newPwd" type="password" allowClear
             autocomplete="new-password"
                              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)" placeholder="新密码" />
          </a-form-model-item>
          <a-form-model-item prop="repeatNewPwd">
            <a-input-password v-model="ruleForm.repeatNewPwd" type="password" allowClear
             autocomplete="new-password"
                              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)" placeholder="确认新密码" />
          </a-form-model-item>
        </a-form-model>
        <a-button class="button" :loading="btnLoading" @click="changePassword">修改密码</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { post, get } from '@/utils/http';
import { pwdPublicKeyEncode } from '@/utils/RSAUtils';
import { message } from 'ant-design-vue';
import api from '@/api';
import { getLogo } from '@/utils/intConfiguration';

export default {
  props: ['value'],
  data() {
    return {
      logoUi: getLogo(),
      btnLoading: false,
      changePWModal: this.value,
      captchaButtonDisabled: false, /// 获取验证码按钮是否禁用
      captchaBtnContent: '获取验证码', // 按钮里显示的内容
      totalTime: 60,
      sendStatus: '',
      codeId: '',
      ruleForm: {
        verifyCode: '',
        newPwd: '',
        repeatNewPwd: '',
      },
      rules: {
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '验证码格式不正确', trigger: 'change' },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
        repeatNewPwd: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
      },
    };
  },

  computed: {
    cssVars() {
      return {
        '--navigationBackColor': this.logoUi.navigationBackColor,
        '--themeColor': this.logoUi.themeColor,
        '--navigationFoldColor': this.logoUi.navigationFoldColor,
      };
    },
  },
  watch: {
    value: {
      handler() {
        this.changePWModal = this.value;
        if (this.changePWModal === true) {
          this.getCaptcha();
        }
      },
    },
    changePWModal: {
      handler() {
        if (!this.changePWModal) {
          this.ruleForm = {
            pwd: '',
            newPwd: '',
            repeatNewPwd: '',
          };
          this.$emit('input', this.changePWModal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    changePassword() {
      if (this.ruleForm.newPwd !== this.ruleForm.repeatNewPwd) {
        message.error('两次输入密码不一致');
        return;
      }
      if (this.codeId.length === 0) {
        message.error('请获取验证码');
        return;
      }
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.btnLoading = true;
            const password = await pwdPublicKeyEncode(this.ruleForm.newPwd);
            const params = {
              verifyCode: this.ruleForm.verifyCode,
              newPassword: password,
              codeId: this.codeId,
            };
            await post(api.forcedModifyPwd, params)
              .then(() => {
                localStorage.setItem('pwdStatus', '1');
                this.changePWModal = false;
                message.success('密码修改成功');
              }).finally(() => {
                this.btnLoading = false;
              }).catch(() => {});
          }
        });
      }, 100);
    },
    // closeEditPasModel() {
    //   this.changePWModal = false;
    // },
    // 修改密码
    changePW() {
      this.changePWModal = true;
    },
    /// 获取验证码倒计时
    countDown() {
      this.captchaButtonDisabled = true;
      this.captchaBtnContent = `${this.totalTime}s`; // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime -= 1;
        this.captchaBtnContent = `${this.totalTime}s`;
        if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.captchaBtnContent = '重新获取';
          this.totalTime = 60;
          this.captchaButtonDisabled = false;
        }
      }, 1000);
    },
    /// 获取验证码
    getCaptcha() {
      setTimeout(async () => {
        this.countDown();
        // const params = {
        //   phone: localStorage.getItem('phone'),
        // };
        const res = await get(api.forcedModifySendCode).catch(() => {
          message.error('验证码发送失败');
        });
        this.codeId = res.codeId;
        this.sendStatus = `验证码已发送至手机号码${res.phone}`;
        if (res) {
          message.success('验证码已发送');
        }
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.sys-sign-out {
  color: #fff;
  //line-height: 60px;
  border-left: 2px solid #E1E4EB;
  //margin: 0 20px 0 30px;
  cursor: pointer;
  font-size: 14px;

  //min-width: 50px;
  .user-name {
    .anticon {
      margin-left: 5px;
    }
  }
}

/deep/ .ant-modal-body {
  padding: 0 56px 56px 56px;

  .modalCloseIcon {
    color: #333;
    top: 24px;
    right: 24px;
    font-size: 22px;
    font-weight: 500;
    position: absolute;
  }

  .send-prompt{
    padding-top: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }
  .modelHeader {
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    color: #2D3968;
    padding-top: 64px;
  }

  .button {
    height: 48px;
    font-size: 16px;
    letter-spacing: 0px;
  }

  .captcha {
    display: flex;
    justify-content: space-between;

    .captchaButton {
      width: auto;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: var(--themeColor);
      border-color: transparent;
      padding: 0;
    }

    .captchaButton:disabled {
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #666666;
      background-color: white;
    }

    .captchaButton:hover {
      background-color: white;
      border: none;
    }

    .ant-input-group-addon {
      background: none;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }

}
</style>
